const getStorageKey = () =>
	typeof window === 'undefined'
		? null
		: window.__ORDER10_MOBILE_PREVIEW_STORAGE_KEY__

let mobilePreviewRecoveryHandler = null
let mobilePreviewRecoveryPromise = null

export const getMobilePreviewSessionId = () => {
	const storageKey = getStorageKey()
	return storageKey ? window.sessionStorage.getItem(storageKey) : null
}

export const isMobilePreviewMode = () => Boolean(getMobilePreviewSessionId())

export const updateMobilePreviewSessionId = sessionId => {
	const storageKey = getStorageKey()
	if (!storageKey || !getMobilePreviewSessionId()) {
		return false
	}
	window.sessionStorage.setItem(storageKey, sessionId)
	return true
}

export const clearMobilePreviewSession = () => {
	const storageKey = getStorageKey()
	if (storageKey) {
		window.sessionStorage.removeItem(storageKey)
	}
}

export const setMobilePreviewRecoveryHandler = handler => {
	mobilePreviewRecoveryHandler = typeof handler === 'function' ? handler : null
}

export const isMobilePreviewAuthenticationFailure = ({
	status,
	errorCode,
	mobilePreviewRequest,
}) =>
	Boolean(mobilePreviewRequest) &&
	(status === 401 || (status === 403 && errorCode === 'FORBIDDEN'))

export const recoverExpiredMobilePreviewSession = () => {
	if (!mobilePreviewRecoveryHandler) {
		return Promise.reject(new Error('手機點餐預覽連線已失效'))
	}
	if (!mobilePreviewRecoveryPromise) {
		const recoveryHandler = mobilePreviewRecoveryHandler
		mobilePreviewRecoveryPromise = Promise.resolve()
			.then(() => recoveryHandler())
			.finally(() => {
				mobilePreviewRecoveryPromise = null
			})
	}
	return mobilePreviewRecoveryPromise
}
